import { createStart, createMiddleware } from "@tanstack/react-start";

import { renderErrorPage } from "./lib/error-page";
import { attachSupabaseAuth } from "@/integrations/supabase/auth-attacher";
import { captureException } from "@/lib/monitoring";

const errorMiddleware = createMiddleware().server(async ({ next, request }) => {
  try {
    if (request?.url) {
      const url = new URL(request.url);
      if (url.pathname.startsWith("/lovable/")) {
        return await next();
      }
    }
    return await next();
  } catch (error) {
    if (error != null && typeof error === "object" && "statusCode" in error) {
      throw error;
    }
    console.error(error);
    captureException(error, {
      source: "server_function",
      location: request?.url,
      severity: "error",
    });
    return new Response(renderErrorPage(), {
      status: 500,
      headers: { "content-type": "text/html; charset=utf-8" },
    });
  }
});

export const startInstance = createStart(() => ({
  functionMiddleware: [attachSupabaseAuth],
  requestMiddleware: [errorMiddleware],
}));
